export const Intervals = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  HALF_YEAR: 'HALF_YEAR',
} as const;

export type IntervalType = (typeof Intervals)[keyof typeof Intervals];
